import React, { Component } from 'react';
import queryString from 'query-string';
import { Toast, Button } from 'antd-mobile';
import styles from './styles.module.less';
import { getImAppId, getImOpenId, acceptInvitePool } from '../../service/chat-service';
import tools from '../../utils/tools';
import bg1 from './img/bg1.png';
import bg2 from './img/bg2.png';

class invitation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: '',
      wxName: '', // 发送人的名称
      wxUrl: '', // 发送人的头像
      show: false,
      openid: '',
    };
  }

  componentDidMount() {
    window.document.title = '邀请讲师';
    this.getLiveOpenId(); // 微信授权
    const windowHref = `?${decodeURIComponent(window.location.href).split('?')[1]}`;
    const { token } = queryString.parse(windowHref);
    const { wxName } = queryString.parse(windowHref);
    const { wxUrl } = queryString.parse(windowHref);
    this.setState({
      token,
      wxName,
      wxUrl,
    });
    this.getLiveOpenId(); // 微信授权
  }

    getLiveOpenId = async () => {
      const windowHref = `?${decodeURIComponent(window.location.href).split('?')[1]}`;
      const WXCode = queryString.parse(windowHref).code;
      this.setState({
        token: queryString.parse(windowHref).token,
      });
      if (!WXCode) {
        localStorage.clear();
        try {
          const { code, data, message } = await getImAppId();
          if (process.env.REACT_APP_API_ENV === 'local') {
            // 本地测试时不走微信验证
            //   this.getLiveDetailLiveInfo('oQd0LwJcSPgP7eYwSy38bUdb793A', 1)
          } else if (code === 10000) window.location.href = tools.toWxth(data);
          else Toast.show(message || '获取微信 appId 失败');
        } catch (e) {
          Toast.show('获取微信 appId 失败');
        }
      } else if (!localStorage.getItem('openId')) {
        try {
          const { code, data } = await getImOpenId(WXCode, 1);
          if (code === 10000) {
            this.setState({
              openid: data.openid,
            });
          }
        } catch (e) {
          Toast.show(e);
        }
      }
    }

    clcikAcceptInvitePool = async () => {
      const { token, openid } = this.state;
      try {
        const { code, message } = await acceptInvitePool({
          token, openId: openid,
        });
        if (code === 10000 || code === 22001) {
          Toast.show(message);
          this.setState({
            show: true,
          });
        } else {
          Toast.show(message);
        }
      } catch (e) {
        Toast.show('接受失败');
      }
    }

    render() {
      const { show, wxName, wxUrl } = this.state;
      return (
        <div>
          {
                    show ? (
                      <div className={styles.poolBox} style={{ background: '#fff' }}>
                        <img src={bg2} alt="" style={{ paddingTop: 10 }} />
                      </div>
                    ) : (
                      <div className={styles.poolBox}>
                        <img src={bg1} className={styles.imgbg} alt="" />
                        <div className={styles.wxInfo}>
                          <span>
                            <img src={wxUrl} alt="" />
                          </span>
                          <span>{wxName}</span>
                        </div>
                        <span className={styles.spans}>邀请您成为特邀讲师</span>
                        <Button className={styles.Buttons} type="primary" onClick={this.clcikAcceptInvitePool}>接受邀请</Button>
                      </div>
                    )
                }
        </div>
      );
    }
}

export default invitation;
